/*
 * EverQuilts - "Build your bundle" on the product page (27.10.2026)
 * Markup + config: snippets/eq-bundle-builder.liquid (rendered from
 * snippets/buy-buttons.liquid). One box: savings cards + bundle builder.
 * Styles: assets/eq-bundle-builder.css.
 *
 * Item 1 is the shirt being viewed (Style / Color / Size read from the main
 * picker). Items 2-5 are picked from a bottom sheet. A picked design starts
 * in the same Style / Color / Size as item 1 when that variant exists and is
 * available; otherwise the closest available variant is used and a note says
 * what changed. "Add bundle to cart" posts every item to /cart/add.js in one
 * request and then opens the cart drawer the same way the main button does.
 *
 * The savings shown come from the "tiers" config in the snippet, built from
 * eq_bb_tiers there - the only place the tier numbers are defined; it must
 * match the store's automatic discounts. No numbers are hard-coded here.
 * The card for the tier the bundle has reached is highlighted.
 *
 * Only runs inside the main product section (product-info#MainProduct-*).
 * Size state comes from assets/eq-cro-pdp.js (info.__eqCro) when present.
 */
(function () {
  'use strict';
  if (window.eqBundleBuilder) return;
  window.eqBundleBuilder = true;

  var productCache = {};
  var builders = [];
  var sheet = null;

  /* ------------------------------------------------------------ helpers */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cents(v) {
    if (typeof v === 'number') return v;
    if (typeof v === 'string') return v.indexOf('.') > -1 ? Math.round(parseFloat(v) * 100) : parseInt(v, 10) || 0;
    return 0;
  }

  function money(c) {
    return '$' + (Number(c) / 100).toFixed(2);
  }

  /* $7 instead of $7.00 for whole-dollar savings. */
  function money0(c) {
    return c % 100 === 0 ? '$' + c / 100 : money(c);
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function findIdx(names, re) {
    for (var i = 0; i < names.length; i++) if (re.test(String(names[i]).trim())) return i;
    return -1;
  }

  /* /products/<handle>.js -> compact { id, handle, title, idx, variants[] } */
  function normalize(p) {
    var names = (p.options || []).map(function (o) {
      return typeof o === 'string' ? o : o && o.name ? o.name : String(o);
    });
    var values = (p.options || []).map(function (o) {
      return (o && o.values) || [];
    });
    return {
      id: p.id,
      handle: p.handle,
      title: p.title || '',
      url: p.url || root() + 'products/' + p.handle,
      image: p.featured_image || (p.images && p.images[0]) || '',
      names: names,
      values: values,
      idx: {
        /* "Style" or "Pick your style" (quilting-shirt products) */
        style: findIdx(names, /style/i),
        color: findIdx(names, /colou?r/i),
        size: findIdx(names, /\bsize\b/i)
      },
      variants: (p.variants || []).map(function (v) {
        return {
          id: v.id,
          o: v.options && v.options.length ? v.options : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }),
          p: cents(v.price),
          a: !!v.available,
          i: v.featured_image ? v.featured_image.src : ''
        };
      })
    };
  }

  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    var pr = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product ' + r.status);
        return r.json();
      })
      .then(normalize)
      .catch(function (err) {
        delete productCache[handle];
        throw err;
      });
    productCache[handle] = pr;
    return pr;
  }

  var KEYS = ['style', 'color', 'size'];
  var LABEL = { style: 'Style', color: 'Color', size: 'Size' };

  function val(prod, v, key) {
    var i = prod.idx[key];
    return i > -1 ? v.o[i] : null;
  }

  function hasKey(prod, key) {
    return prod.idx[key] > -1;
  }

  /* Exact, available variant for a {style,color,size} choice. */
  function exact(prod, sel) {
    for (var i = 0; i < prod.variants.length; i++) {
      var v = prod.variants[i];
      var ok = KEYS.every(function (k) {
        return !hasKey(prod, k) || val(prod, v, k) === sel[k];
      });
      if (ok) return v;
    }
    return null;
  }

  /* Loose value match across products: "Ladies' V-Neck" = "Ladies V-Neck",
     "Mauve" = "Heather Mauve" (older listings use slightly different names). */
  function norm(x) {
    return String(x == null ? '' : x).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function same(a, b) {
    if (a === b) return true;
    var x = norm(a);
    var y = norm(b);
    if (!x || !y) return false;
    return x === y || (x.length > 3 && y.length > 3 && (x.slice(-y.length) === y || y.slice(-x.length) === x));
  }

  /*
   * Closest available variant to `want`. `order` is a list of key sets tried
   * in turn; a null want[k] is a wildcard. Returns the new selection and a
   * note naming every value that had to change.
   */
  function fit(prod, want, order) {
    var avail = prod.variants.filter(function (v) { return v.a; });
    if (!avail.length) return null;
    for (var s = 0; s < order.length; s++) {
      var keys = order[s];
      for (var i = 0; i < avail.length; i++) {
        var v = avail[i];
        var ok = keys.every(function (k) {
          return !hasKey(prod, k) || want[k] == null || same(val(prod, v, k), want[k]);
        });
        if (!ok) continue;
        var sel = {};
        var changed = [];
        KEYS.forEach(function (k) {
          if (!hasKey(prod, k)) {
            sel[k] = null;
            return;
          }
          var got = val(prod, v, k);
          if (k === 'size' && want.size == null) {
            sel.size = null;
            return;
          }
          sel[k] = got;
          if (want[k] != null && !same(got, want[k])) changed.push(want[k] + ' → ' + got);
        });
        return {
          sel: sel,
          note: changed.length ? 'Not available in this design: ' + changed.join(', ') + '.' : ''
        };
      }
    }
    return null;
  }

  var SYNC_ORDER = [
    ['style', 'color', 'size'],
    ['style', 'size'],
    ['color', 'size'],
    ['size'],
    ['style', 'color'],
    ['style'],
    []
  ];

  function editOrder(first) {
    var others = KEYS.filter(function (k) { return k !== first; });
    return [
      ['style', 'color', 'size'],
      first === 'size' ? ['size', others[0]] : [first, 'size'],
      first === 'size' ? ['size', others[1]] : [first, others.filter(function (k) { return k !== 'size'; })[0]],
      [first],
      []
    ];
  }

  /* Lowest available price for a selection whose size is still open. */
  function minPrice(prod, sel) {
    var best = null;
    prod.variants.forEach(function (v) {
      if (!v.a) return;
      if (hasKey(prod, 'style') && sel.style != null && val(prod, v, 'style') !== sel.style) return;
      if (hasKey(prod, 'color') && sel.color != null && val(prod, v, 'color') !== sel.color) return;
      if (best === null || v.p < best) best = v.p;
    });
    return best;
  }

  function imageFor(prod, sel) {
    var v = exact(prod, sel);
    if (v && v.i) return v.i;
    for (var i = 0; i < prod.variants.length; i++) {
      var x = prod.variants[i];
      if (x.i && (!hasKey(prod, 'color') || val(prod, x, 'color') === sel.color)) return x.i;
    }
    return prod.image;
  }

  function optionsText(prod, sel) {
    return KEYS.filter(function (k) { return hasKey(prod, k) && sel[k]; })
      .map(function (k) { return sel[k]; })
      .join(' · ');
  }

  /* ------------------------------------------------------------ main shirt */

  function mainState(B) {
    var ctx = B.info.__eqCro;
    var prod = B.main;
    var sizeUnset = !!(ctx && ctx.useSize && !ctx.chosen);
    var checked = {};
    var picker = B.info.querySelector('variant-selects');
    if (picker) {
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        if (input.dataset.optionName) checked[input.dataset.optionName.toLowerCase()] = input.value;
      });
      picker.querySelectorAll('select').forEach(function (select) {
        var m = (select.name || '').match(/options\[(.+)\]/);
        if (m) checked[m[1].toLowerCase()] = select.value;
      });
    }
    var sel = { style: null, color: null, size: null };
    var variant = null;
    if (prod) {
      KEYS.forEach(function (k) {
        var i = prod.idx[k];
        if (i > -1) sel[k] = checked[String(prod.names[i]).toLowerCase()] || null;
      });
      variant = exact(prod, sel);
      if (!variant) {
        var form = document.getElementById('product-form-' + B.section);
        var input = form && form.querySelector('input[name="id"]');
        var id = input && Number(input.value);
        for (var j = 0; j < prod.variants.length; j++) {
          if (prod.variants[j].id === id) {
            variant = prod.variants[j];
            break;
          }
        }
        if (variant) KEYS.forEach(function (k) { if (hasKey(prod, k)) sel[k] = val(prod, variant, k); });
      }
      if (!hasKey(prod, 'size')) sizeUnset = false;
    }
    if (sizeUnset) sel.size = null;
    return { sel: sel, variant: variant, sizeUnset: sizeUnset };
  }

  function nudgeSize(B) {
    var st = mainState(B);
    if (!st.sizeUnset) return;
    var btn = document.getElementById('ProductSubmitButton-' + B.section);
    /* eq-cro-pdp.js stops this submit and scrolls to Size with a message. */
    if (btn && B.info.__eqCro && B.info.__eqCro.useSize && !B.info.__eqCro.chosen) {
      btn.click();
      return;
    }
    var radio = B.info.querySelector('variant-selects input[type="radio"][data-option-name="Size"]');
    var fs = radio && radio.closest('fieldset');
    if (fs) fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ------------------------------------------------------------ slots */

  function syncSlot(B, slot, st) {
    if (!slot.prod) return;
    var r = fit(slot.prod, st.sel, SYNC_ORDER);
    if (!r) {
      slot.soldOut = true;
      return;
    }
    slot.soldOut = false;
    slot.sel = r.sel;
    slot.note = r.note;
  }

  function pickDesign(B, index, handle) {
    var slot = { handle: handle, loading: true, sync: true, sel: {}, note: '' };
    B.slots[index] = slot;
    B.message = '';
    render(B);
    loadProduct(handle)
      .then(function (prod) {
        if (B.slots[index] !== slot) return;
        slot.prod = prod;
        slot.loading = false;
        syncSlot(B, slot, mainState(B));
        if (slot.soldOut) {
          B.slots[index] = null;
          B.message = 'Sorry, that design is sold out. Please choose another one.';
        }
        render(B);
      })
      .catch(function () {
        if (B.slots[index] !== slot) return;
        B.slots[index] = null;
        B.message = 'Sorry, we could not load that design. Please try again.';
        render(B);
      });
  }

  function editSlot(B, index, key, value) {
    var slot = B.slots[index];
    if (!slot || !slot.prod) return;
    slot.sync = false;
    var want = {};
    KEYS.forEach(function (k) { want[k] = slot.sel[k]; });
    want[key] = value || null;
    if (want.size == null) {
      var r0 = fit(slot.prod, want, editOrder(key));
      if (r0) {
        slot.sel = r0.sel;
        slot.note = r0.note;
      }
    } else {
      var r = exact(slot.prod, want) && exact(slot.prod, want).a ? { sel: want, note: '' } : fit(slot.prod, want, editOrder(key));
      if (r) {
        slot.sel = r.sel;
        slot.note = r.note;
      }
    }
    render(B, '[data-eq-bb-sel="' + index + ':' + key + '"]');
  }

  /* ------------------------------------------------------------ totals */

  function tierFor(B, n) {
    var cur = null;
    var next = null;
    B.cfg.tiers.forEach(function (t) {
      if (t.qty <= n) cur = t;
      else if (!next) next = t;
    });
    return { cur: cur, next: next };
  }

  function hintText(B, n) {
    var t = tierFor(B, n);
    var parts = [];
    if (t.cur) parts.push(t.cur.off ? money0(t.cur.off) + ' off applied' : 'Free US shipping unlocked');
    if (t.next) {
      var more = t.next.qty - n;
      var item = more === 1 ? 'tee' : 'tees';
      var goal = t.next.off ? 'to save ' + money0(t.next.off) : 'for free US shipping';
      var text = 'add ' + more + ' more ' + item + ' ' + goal;
      if (!parts.length) text = text.charAt(0).toUpperCase() + text.slice(1);
      parts.push(text);
    }
    return parts.join(' · ');
  }

  function summary(B, st) {
    var items = [];
    var complete = true;
    var missing = [];
    var soldOut = false;
    var mainUnavailable = !st.sizeUnset && !!B.main && (!st.variant || !st.variant.a);

    if (st.sizeUnset || !st.variant) {
      complete = false;
      if (st.sizeUnset) missing.push(1);
      items.push(B.main ? minPrice(B.main, st.sel) || 0 : 0);
    } else {
      if (!st.variant.a) soldOut = true;
      items.push(st.variant.p);
    }
    var ids = st.variant && !st.sizeUnset ? [st.variant.id] : [];

    B.slots.forEach(function (slot, i) {
      if (!slot) return;
      if (!slot.prod) {
        complete = false;
        items.push(0);
        return;
      }
      var v = slot.sel.size != null || !hasKey(slot.prod, 'size') ? exact(slot.prod, slot.sel) : null;
      if (v && v.a) {
        items.push(v.p);
        ids.push(v.id);
      } else {
        complete = false;
        if (slot.sel.size == null && hasKey(slot.prod, 'size')) missing.push(i + 2);
        else soldOut = true;
        items.push(minPrice(slot.prod, slot.sel) || 0);
      }
    });

    return {
      count: items.length,
      total: items.reduce(function (a, b) { return a + b; }, 0),
      complete: complete,
      missing: missing,
      soldOut: soldOut,
      mainUnavailable: mainUnavailable,
      ids: ids
    };
  }

  /* ------------------------------------------------------------ render */

  function mainRow(B, st) {
    var prod = B.main;
    var img = prod ? imageFor(prod, st.sel) : B.root.dataset.image;
    var title = prod ? prod.title : B.root.dataset.title;
    var opts = prod ? optionsText(prod, st.sel) : '';
    var price = '';
    if (prod) {
      if (st.sizeUnset) {
        var m = minPrice(prod, st.sel);
        price = m != null ? 'From ' + money(m) : '';
      } else if (st.variant && st.variant.a) {
        price = money(st.variant.p);
      } else {
        price = 'Unavailable';
      }
    }
    var sizeLine = st.sizeUnset
      ? '<button type="button" class="eq-bb__link eq-bb__link--warn" data-eq-bb-size>Choose your size above</button>'
      : '';
    return (
      '<div class="eq-bb__item eq-bb__item--main">' +
      '<div class="eq-bb__head">' +
      (img ? '<img class="eq-bb__thumb" src="' + esc(imgUrl(img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="eq-bb__thumb"></span>') +
      '<div class="eq-bb__info">' +
      '<span class="eq-bb__tag">Item 1 · This design</span>' +
      '<span class="eq-bb__name">' + esc(title) + '</span>' +
      (opts ? '<span class="eq-bb__opts">' + esc(opts) + '</span>' : '') +
      sizeLine +
      '</div>' +
      '<span class="eq-bb__price">' + esc(price) + '</span>' +
      '</div>' +
      '</div>'
    );
  }

  function selectHtml(slot, index, key) {
    var prod = slot.prod;
    var i = prod.idx[key];
    if (i < 0) return '';
    var values = (prod.values[i] && prod.values[i].length ? prod.values[i] : []).slice();
    if (!values.length) {
      prod.variants.forEach(function (v) {
        if (values.indexOf(v.o[i]) === -1) values.push(v.o[i]);
      });
    }
    var cur = slot.sel[key];
    var html =
      '<label class="eq-bb__field eq-bb__field--' + key + '">' +
      '<span class="eq-bb__field-label">' + LABEL[key] + '</span>' +
      '<select data-eq-bb-sel="' + index + ':' + key + '" aria-label="' + LABEL[key] + ' for item ' + (index + 2) + '"' +
      (key === 'size' && cur == null ? ' class="is-empty"' : '') + '>';
    if (cur == null) html += '<option value="" selected>Choose</option>';
    values.forEach(function (v) {
      html += '<option value="' + esc(v) + '"' + (v === cur ? ' selected' : '') + '>' + esc(v) + '</option>';
    });
    return html + '</select></label>';
  }

  function slotRow(B, slot, index) {
    var n = index + 2;
    if (!slot) {
      return (
        '<button type="button" class="eq-bb__slot" data-eq-bb-open="' + index + '">' +
        '<span class="eq-bb__plus" aria-hidden="true">+</span>' +
        '<span class="eq-bb__slot-text"><strong>Add item ' + n + '</strong><span>Choose a design</span></span>' +
        '</button>'
      );
    }
    if (!slot.prod) {
      return '<div class="eq-bb__item eq-bb__item--loading"><span class="eq-bb__tag">Item ' + n + '</span><span class="eq-bb__opts">Loading design…</span></div>';
    }
    var prod = slot.prod;
    var v = exact(prod, slot.sel);
    var price = v && slot.sel.size != null ? money(v.p) : (function () {
      var m = minPrice(prod, slot.sel);
      return m != null ? 'From ' + money(m) : '';
    })();
    var img = imageFor(prod, slot.sel);
    return (
      '<div class="eq-bb__item" data-eq-bb-slot="' + index + '">' +
      '<div class="eq-bb__head">' +
      (img ? '<img class="eq-bb__thumb" src="' + esc(imgUrl(img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="eq-bb__thumb"></span>') +
      '<div class="eq-bb__info">' +
      '<span class="eq-bb__tag">Item ' + n + '</span>' +
      '<span class="eq-bb__name">' + esc(prod.title) + '</span>' +
      '<button type="button" class="eq-bb__link" data-eq-bb-open="' + index + '">Change design</button>' +
      '</div>' +
      '<span class="eq-bb__price">' + esc(price) + '</span>' +
      '<button type="button" class="eq-bb__remove" data-eq-bb-remove="' + index + '" aria-label="Remove item ' + n + '">' +
      '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="eq-bb__selects">' +
      selectHtml(slot, index, 'style') +
      selectHtml(slot, index, 'color') +
      selectHtml(slot, index, 'size') +
      '</div>' +
      (slot.note ? '<p class="eq-bb__note">' + esc(slot.note) + '</p>' : '') +
      '</div>'
    );
  }

  /* Highlight the savings card the bundle has reached (none below tier 1). */
  function markTier(B, n) {
    var cur = tierFor(B, n).cur;
    B.tierEls.forEach(function (li) {
      var on = !!cur && Number(li.getAttribute('data-eq-bb-tier')) === cur.qty;
      li.classList.toggle('is-active', on);
      if (on) li.setAttribute('aria-current', 'true');
      else li.removeAttribute('aria-current');
    });
  }

  function render(B, focusSel) {
    var st = mainState(B);
    var active = document.activeElement;
    var refocus = focusSel || (active && B.root.contains(active) && active.matches('select[data-eq-bb-sel]')
      ? '[data-eq-bb-sel="' + active.getAttribute('data-eq-bb-sel') + '"]'
      : null);

    var html = mainRow(B, st);
    for (var i = 0; i < B.rows; i++) html += slotRow(B, B.slots[i], i);
    if (B.rows < B.cfg.max - 1) {
      html += '<button type="button" class="eq-bb__more" data-eq-bb-more>+ Add item ' + (B.rows + 2) + '</button>';
    }
    B.itemsEl.innerHTML = html;

    if (!B.main) {
      B.summaryEl.innerHTML = '';
      B.addBtn.disabled = true;
      B.ids = null;
      markTier(B, 1 + B.slots.filter(Boolean).length);
      return;
    }
    var s = summary(B, st);
    var t = tierFor(B, s.count);
    markTier(B, s.count);
    var sum =
      '<div class="eq-bb__total"><span>Bundle total · ' + s.count + (s.count === 1 ? ' item' : ' items') + '</span>' +
      '<strong>' + (s.mainUnavailable ? '—' : (s.complete ? '' : 'From ') + money(s.total)) + '</strong></div>';
    if (t.cur && t.cur.off) {
      sum += '<p class="eq-bb__save">You save ' + money0(t.cur.off) + ' <span>· applied automatically in your cart</span></p>';
    }
    sum += '<p class="eq-bb__hint">' + esc(hintText(B, s.count)) + '</p>';
    if (B.cartCount > 0) sum += '<p class="eq-bb__fine">Shirts already in your cart count toward these savings too.</p>';
    B.summaryEl.innerHTML = sum;

    var ready = s.count >= 2 && s.complete && !s.soldOut && !B.busy;
    B.addBtn.disabled = !ready;
    B.addBtn.classList.toggle('is-loading', !!B.busy);
    B.addBtn.textContent = B.busy ? 'Adding…' : 'Add bundle to cart';
    B.ids = ready ? s.ids : null;

    var msg = B.message;
    if (!msg && s.mainUnavailable) {
      msg = 'This design is not available in the style and color chosen above. Please pick another option.';
    } else if (!msg && s.count >= 2) {
      if (s.missing.length) {
        var others = s.missing.filter(function (n) { return n !== 1; });
        var bits = [];
        if (others.length !== s.missing.length) bits.push('choose your size in the options above');
        if (others.length) bits.push('choose a size for item ' + others.join(', item '));
        msg = bits.join(' and ');
        msg = msg.charAt(0).toUpperCase() + msg.slice(1) + '.';
      } else if (s.soldOut) {
        msg = 'One of these items is sold out in the chosen options. Please pick another color or size.';
      }
    }
    B.msgEl.textContent = msg || '';
    B.msgEl.hidden = !msg;
    B.msgEl.classList.toggle('is-ok', !!B.messageOk && msg === B.message);

    if (refocus) {
      var el = B.root.querySelector(refocus);
      if (el) {
        try {
          el.focus({ preventScroll: true });
        } catch (e) {
          el.focus();
        }
      }
    }
  }

  /* Main picker changed: refresh item 1 and every slot still following it. */
  function refresh(B) {
    if (!B.main) return render(B);
    var st = mainState(B);
    B.slots.forEach(function (slot) {
      if (!slot || !slot.prod) return;
      if (slot.sync) syncSlot(B, slot, st);
      else if (slot.sel.size == null && st.sel.size != null) {
        var want = { style: slot.sel.style, color: slot.sel.color, size: st.sel.size };
        var r = fit(slot.prod, want, editOrder('size'));
        if (r) {
          slot.sel = r.sel;
          slot.note = r.note;
        }
      }
    });
    render(B);
  }

  /* ------------------------------------------------------------ cart */

  function cartCount(B) {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        B.cartCount = (c && c.item_count) || 0;
        render(B);
      })
      .catch(function () {});
  }

  function friendly(res) {
    var d = String((res && (res.description || res.message)) || '');
    if (/sold out|not available|unavailable|inventory|quantity|already/i.test(d)) {
      return 'Sorry, one of these items just sold out in the chosen options. Please pick another color or size and try again.';
    }
    return "Sorry, we couldn't add your bundle right now. Please try again.";
  }

  function addBundle(B) {
    if (B.busy || !B.ids || B.ids.length < 2) return;
    var ids = B.ids.slice();
    var drawer = document.querySelector('cart-drawer');
    var payload = {
      items: ids.map(function (id) {
        return { id: id, quantity: 1 };
      })
    };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(B.addBtn);
    }
    B.busy = true;
    B.message = '';
    render(B);

    fetch(((window.routes && window.routes.cart_add_url) || root() + 'cart/add') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        B.busy = false;
        if (!res || res.status) {
          B.message = friendly(res);
          B.messageOk = false;
          render(B);
          return;
        }
        B.slots = [];
        B.message = 'Bundle added to your cart.';
        B.messageOk = true;
        B.cartCount = (B.cartCount || 0) + ids.length;
        render(B);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'eq-bundle-builder', productVariantId: ids[0], cartData: res });
        }
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root() + 'cart';
        }
      })
      .catch(function () {
        B.busy = false;
        B.message = 'Connection problem. Please check your internet and try again.';
        B.messageOk = false;
        render(B);
      });
  }

  /* ------------------------------------------------------------ sheet */

  function buildSheet() {
    if (sheet) return sheet;
    var el = document.createElement('div');
    el.className = 'eq-bb-sheet';
    el.hidden = true;
    el.innerHTML =
      '<div class="eq-bb-sheet__overlay" data-eq-bb-close></div>' +
      '<div class="eq-bb-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="EqBbSheetTitle">' +
      '<div class="eq-bb-sheet__head">' +
      '<p class="eq-bb-sheet__title" id="EqBbSheetTitle">Choose a design</p>' +
      '<button type="button" class="eq-bb-sheet__close" data-eq-bb-close aria-label="Close">' +
      '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div>' +
      '<div class="eq-bb-sheet__search">' +
      '<input type="search" placeholder="Search designs, e.g. cat, floral" aria-label="Search designs" autocomplete="off" enterkeyhint="search">' +
      '</div>' +
      '<div class="eq-bb-sheet__body">' +
      '<p class="eq-bb-sheet__status" aria-live="polite"></p>' +
      '<ul class="eq-bb-sheet__grid" role="list"></ul>' +
      '</div>' +
      '</div>';
    document.body.appendChild(el);

    sheet = {
      el: el,
      input: el.querySelector('input'),
      grid: el.querySelector('.eq-bb-sheet__grid'),
      status: el.querySelector('.eq-bb-sheet__status'),
      title: el.querySelector('.eq-bb-sheet__title'),
      B: null,
      index: 0,
      timer: null,
      reqId: 0,
      lastFocus: null
    };

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-eq-bb-close]')) {
        closeSheet();
        return;
      }
      var card = e.target.closest('[data-eq-bb-pick]');
      if (card && sheet.B) {
        var B = sheet.B;
        var index = sheet.index;
        closeSheet(true);
        pickDesign(B, index, card.getAttribute('data-eq-bb-pick'));
      }
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
      if (e.key === 'Enter' && e.target === sheet.input) e.preventDefault();
    });
    sheet.input.addEventListener('input', function () {
      clearTimeout(sheet.timer);
      sheet.timer = setTimeout(runSearch, 250);
    });
    return sheet;
  }

  function cardHtml(d) {
    return (
      '<li><button type="button" class="eq-bb-card" data-eq-bb-pick="' + esc(d.h) + '">' +
      (d.i ? '<img src="' + esc(imgUrl(d.i, 300)) + '" alt="" width="300" height="300" loading="lazy">' : '<span class="eq-bb-card__ph"></span>') +
      '<span class="eq-bb-card__t">' + esc(d.t) + '</span>' +
      (d.p ? '<span class="eq-bb-card__p">From ' + money(d.p) + '</span>' : '') +
      '</button></li>'
    );
  }

  function showList(list, status) {
    sheet.grid.innerHTML = list.map(cardHtml).join('');
    sheet.status.textContent = status || '';
    sheet.status.hidden = !status;
  }

  function words(q) {
    return q.toLowerCase().split(/\s+/).filter(Boolean);
  }

  function runSearch() {
    var B = sheet.B;
    if (!B) return;
    var q = sheet.input.value.trim();
    var base = B.designs;
    if (!q) {
      showList(base, base.length ? '' : 'Loading designs…');
      return;
    }
    var w = words(q);
    var local = base.filter(function (d) {
      var t = d.t.toLowerCase();
      return w.every(function (x) { return t.indexOf(x) > -1; });
    });
    showList(local, local.length ? '' : 'Searching…');
    if (q.length < 2) return;
    var id = ++sheet.reqId;
    var url =
      root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (id !== sheet.reqId || sheet.B !== B) return;
        var seen = {};
        local.forEach(function (d) { seen[d.h] = true; });
        var found = (((data || {}).resources || {}).results || {}).products || [];
        var extra = [];
        found.forEach(function (p) {
          if (!p || !p.handle || seen[p.handle] || p.available === false) return;
          seen[p.handle] = true;
          extra.push({
            h: p.handle,
            t: p.title,
            i: (p.featured_image && p.featured_image.url) || p.image || '',
            p: cents(p.price_min != null ? p.price_min : p.price)
          });
        });
        var all = local.concat(extra);
        showList(all, all.length ? '' : 'No designs found for “' + q + '”. Try another word.');
      })
      .catch(function () {
        if (id !== sheet.reqId) return;
        if (!local.length) showList([], 'No designs found for “' + q + '”. Try another word.');
      });
  }

  function openSheet(B, index) {
    buildSheet();
    sheet.B = B;
    sheet.index = index;
    sheet.lastFocus = document.activeElement;
    sheet.title.textContent = 'Choose a design for item ' + (index + 2);
    sheet.input.value = '';
    sheet.el.hidden = false;
    document.documentElement.classList.add('eq-bb-lock');
    document.body.classList.add('eq-bb-open');
    requestAnimationFrame(function () {
      sheet.el.classList.add('is-open');
    });
    ensureDesigns(B).then(function () {
      if (sheet.B === B && !sheet.input.value.trim()) runSearch();
    });
    runSearch();
    var close = sheet.el.querySelector('.eq-bb-sheet__close');
    try {
      close.focus({ preventScroll: true });
    } catch (e) {
      close.focus();
    }
  }

  function closeSheet(keepFocus) {
    if (!sheet || sheet.el.hidden) return;
    sheet.el.classList.remove('is-open');
    sheet.el.hidden = true;
    document.documentElement.classList.remove('eq-bb-lock');
    document.body.classList.remove('eq-bb-open');
    sheet.reqId++;
    var last = sheet.lastFocus;
    sheet.B = null;
    if (!keepFocus && last && last.isConnected) {
      try {
        last.focus({ preventScroll: true });
      } catch (e) {
        last.focus();
      }
    }
  }

  /* Designs come from the snippet; Shopify recommendations are the backup. */
  function ensureDesigns(B) {
    if (B.designs.length || B.designsLoading) return B.designsLoading || Promise.resolve();
    var url = root() + 'recommendations/products.json?product_id=' + B.productId + '&limit=12&intent=related';
    B.designsLoading = fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        B.designs = ((data && data.products) || [])
          .filter(function (p) { return p.available && String(p.id) !== String(B.productId); })
          .map(function (p) {
            return { h: p.handle, t: p.title, i: p.featured_image || '', p: cents(p.price_min != null ? p.price_min : p.price) };
          });
      })
      .catch(function () {})
      .then(function () {
        B.designsLoading = null;
      });
    return B.designsLoading;
  }

  /* ------------------------------------------------------------ wiring */

  function init(el) {
    if (el.__eqBb) return;
    var info = el.closest('product-info[id^="MainProduct-"]');
    if (!info) return;
    var cfg = { tiers: [], max: 5, designs: [] };
    try {
      var tag = el.querySelector('script[data-eq-bb-config]');
      if (tag) cfg = JSON.parse(tag.textContent);
    } catch (e) {
      /* keep defaults */
    }
    if (!cfg.tiers || !cfg.tiers.length) return;
    var B = {
      root: el,
      info: info,
      section: el.dataset.section || info.dataset.section,
      productId: el.dataset.productId,
      cfg: cfg,
      designs: (cfg.designs || []).filter(function (d) { return d && d.h; }),
      main: null,
      slots: [],
      rows: Math.min(3, (cfg.max || 5) - 1),
      itemsEl: el.querySelector('[data-eq-bb-items]'),
      summaryEl: el.querySelector('[data-eq-bb-summary]'),
      msgEl: el.querySelector('[data-eq-bb-msg]'),
      addBtn: el.querySelector('[data-eq-bb-add]'),
      tierEls: Array.prototype.slice.call(el.querySelectorAll('[data-eq-bb-tier]')),
      cartCount: 0,
      busy: false,
      message: ''
    };
    el.__eqBb = B;
    builders.push(B);

    /* 01.11.2026 - "Shop Bundle" cards (assets/eq-pdp-redesign.js) open this
       builder with a preset bundle size: n items = item 1 + (n - 1) slots.
       Slots past the new size are dropped. */
    el.eqBbSetSize = function (n) {
      n = Math.max(2, Math.min(Number(n) || 2, B.cfg.max || 5));
      B.rows = n - 1;
      B.slots = B.slots.slice(0, B.rows);
      B.message = '';
      render(B);
    };

    el.addEventListener('click', function (e) {
      var t = e.target;
      var open = t.closest('[data-eq-bb-open]');
      if (open) {
        e.preventDefault();
        openSheet(B, Number(open.getAttribute('data-eq-bb-open')));
        return;
      }
      var rm = t.closest('[data-eq-bb-remove]');
      if (rm) {
        e.preventDefault();
        var i = Number(rm.getAttribute('data-eq-bb-remove'));
        B.slots[i] = null;
        B.message = '';
        render(B);
        var next = B.root.querySelector('[data-eq-bb-open="' + i + '"]');
        if (next) next.focus();
        return;
      }
      if (t.closest('[data-eq-bb-more]')) {
        e.preventDefault();
        B.rows = Math.min(B.rows + 1, B.cfg.max - 1);
        render(B);
        var added = B.root.querySelector('[data-eq-bb-open="' + (B.rows - 1) + '"]');
        if (added) added.focus();
        return;
      }
      if (t.closest('[data-eq-bb-size]')) {
        e.preventDefault();
        nudgeSize(B);
        return;
      }
      if (t.closest('[data-eq-bb-add]')) {
        e.preventDefault();
        addBundle(B);
      }
    });

    el.addEventListener('change', function (e) {
      var s = e.target.closest && e.target.closest('select[data-eq-bb-sel]');
      if (!s) return;
      e.stopPropagation();
      var parts = s.getAttribute('data-eq-bb-sel').split(':');
      B.message = '';
      editSlot(B, Number(parts[0]), parts[1], s.value);
    });

    el.hidden = false;
    render(B);
    loadProduct(el.dataset.handle)
      .then(function (prod) {
        B.main = prod;
        render(B);
      })
      .catch(function () {
        el.hidden = true;
      });
    cartCount(B);
  }

  function initAll() {
    builders = builders.filter(function (B) { return B.root.isConnected; });
    document.querySelectorAll('[data-eq-bb]').forEach(init);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      initAll();
      builders.forEach(refresh);
    }, 120);
  }

  function onPicker(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects')) return;
    schedule();
  }

  function start() {
    initAll();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, schedule);
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'eq-bundle-builder') return;
        builders.forEach(cartCount);
      });
    }
  }

  document.addEventListener('click', onPicker, true);
  document.addEventListener('change', onPicker, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
